import styled from 'styled-components';
import MediaQueryBreakpoints from '@rockalingua/ui/constants/MediaQueryBreakpoints';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;

  @media ${MediaQueryBreakpoints.isXsm} {
    align-items: center;
  }
`;
